import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7a9e9afb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "ratio-wrapper"
}
const _hoisted_3 = { class: "ratio-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { reactive, ref, onMounted, nextTick, computed, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import { listCol } from '@/utils/list-columns-i18n'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'

import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import TerminalIconName from '@/views/dashboard/_components/terminal-icon-name/terminal-icon-name.vue'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'
import GroupTreeSelector from '@/views/dashboard/_components/group-tree-selector/group-tree-selector.vue'
import {
  TerminalViewService,
  SoftwareUsageData as TerminalUsageData,
  SoftwareUsageReq as TerminalUsageReq,
} from '../terminal-view/terminal-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  FormSize,
  FormType,
  ObjectFormItem,
  DateType,
} from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { formatDuration } from '@/utils/time'
import dayjs from 'dayjs'
import { useParseTime } from '@/hooks'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-usage-list',
  props: {
    viewMode: { default: TableViewMode.preview },
    hasPermission: { type: Boolean, default: true },
    dateRange: { default: () =>
      [dayjs().subtract(3, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')] as [string, string] }
  },
  emits: ['viewAll', 'detail'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
function threeMonthRange (): [string, string] {
  return [dayjs().subtract(3, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
}

/** 活跃软件数/已安装软件数，用于进度条（0–100） */
function activeInstallSoftPercent (row: { active_soft_count?: number; install_soft_count?: number }): number {
  const install = row.install_soft_count ?? 0
  if (!install) return 0
  return Math.min(100, Number((((row.active_soft_count ?? 0) / install) * 100).toFixed(1)))
}

const props = __props

const emits = __emit

const injector = useReflectiveInjector([TerminalViewService])
const terminalService = injector.get(TerminalViewService)
const hasPermission = props.hasPermission

function dataApi(params: any) {
  return terminalService.getSoftwareUsage({
    ...params,
    key_word: queryParams.key_word || undefined,
    start_time: queryParams.start_time != null ? String(queryParams.start_time) : undefined,
    end_time: queryParams.end_time != null ? String(queryParams.end_time) : undefined
  })
}

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const total = computed(() => tableRef.value?.total || 0)

const initialRange = props.dateRange?.length === 2 ? props.dateRange : threeMonthRange()
const [initialStartTime, initialEndTime] = useParseTime(initialRange)

const queryParams = reactive<TerminalUsageReq & { dateRange?: [string, string]; key_word?: string }>({
  key_word: '',
  group_id: -1,
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  sort: 'duration',
  asc: false,
  dateRange: initialRange,
  start_time: initialStartTime != null ? String(initialStartTime) : undefined,
  end_time: initialEndTime != null ? String(initialEndTime) : undefined
})

const groupTreeDefaultId = computed<number | null>(() => {
  const g = queryParams.group_id
  if (g == null || String(g) === '-1') return null
  const n = Number(g)
  return Number.isFinite(n) ? n : null
})

const filterFormColumns = computed<ObjectFormItem<typeof queryParams, 'dateRange' | 'group_id'>>(() => {
  void locale.value
  return {
    group_id: {
      prop: 'group_id',
      colOpt: { style: 'flex: 0 0 150px' },
      slot: true,
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      events: {
        change: () => {
          handleQuery()
        },
      },
    },
    dateRange: {
      prop: 'dateRange',
      label: t('genuineSoftwareUsage.timeRange'),
      type: FormType.Date,
      dateType: DateType.DateRange,
      colOpt: { style: 'width: 260px; flex: 0 0 auto' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      dateOpt: {
        clearable: false,
        'value-format': 'YYYY-MM-DD',
        'start-placeholder': t('common.startDate'),
        'end-placeholder': t('common.endDate'),
      },
      events: {
        change: (val: [string, string] | undefined) => {
          if (val?.length === 2) {
            const [s, e] = useParseTime(val)
            queryParams.start_time = s != null ? String(s) : undefined
            queryParams.end_time = e != null ? String(e) : undefined
          } else {
            queryParams.start_time = undefined
            queryParams.end_time = undefined
          }
          handleQuery()
        },
      },
    },
  }
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: listCol(t, 'operation'), width: 100, fixed: 'right' },
    actionButtons: () => [
      { name: listCol(t, 'detail'), type: 'detail', opt: { size: FormSize.Small, text: true, type: 'text' } }
    ]
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
    path: 'list',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: 'device_id',
    selection: false,
    showTip: false,
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      { prop: 'computer_name', label: listCol(t, 'computerName'), columnOpt: { minWidth: 200 } },
      { prop: 'group_name', label: listCol(t, 'groupName'), columnOpt: { minWidth: 120 } },
      { prop: 'user_mark', label: listCol(t, 'userMark'), columnOpt: { minWidth: 120 } },
      { prop: 'ip_address', label: listCol(t, 'ipAddress'), columnOpt: { minWidth: 200 } },
      { prop: 'system_name', label: t('portManage.osPlaceholder'), columnOpt: { minWidth: 200 } },
      { prop: 'active_install_ratio', label: t('softwareUsage.activeSoftInstall'), columnOpt: { minWidth: 180 } },
    ],
    totalPath: 'total',
    tableActOpt: tableActOpt.value
  }
})

async function handleSearch(value: string) {
  await nextTick()
  queryParams.key_word = value
  queryParams.page = 1
  void refreshList()
}

async function handleQuery() {
  queryParams.page = 1
  await refreshList()
}

async function updateGroupId (groupId: number) {
  queryParams.group_id = groupId
  queryParams.page = 1
  await refreshList()
}

function handleReset() {
  const range = [dayjs().subtract(3, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')] as [string, string]
  const [s, e] = useParseTime(range)
  queryParams.key_word = ''
  queryParams.group_id = -1
  queryParams.dateRange = range
  queryParams.start_time = s != null ? String(s) : undefined
  queryParams.end_time = e != null ? String(e) : undefined
  queryParams.page = 1
  void refreshList()
}

function handleAction({ type, rowItem }: { type: string; rowItem: TerminalUsageData }) {
  if (type === 'detail') {
    handleDetail(rowItem)
  }
}

function handleDetail(item: TerminalUsageData) {
  emits('detail', item)
}

function download(type: 0 | 1) {
  terminalService.download(type, {
    key_word: queryParams.key_word,
    start_time: queryParams.start_time != null ? String(queryParams.start_time) : undefined,
    end_time: queryParams.end_time != null ? String(queryParams.end_time) : undefined
  } as TerminalUsageReq, t('softwareUsage.exportTerminalView'))
}

watch(
  () => props.dateRange,
  async (v) => {
    if (!v?.length || v.length !== 2) return
    const [s, e] = useParseTime(v)
    queryParams.dateRange = v as [string, string]
    queryParams.start_time = s != null ? String(s) : undefined
    queryParams.end_time = e != null ? String(e) : undefined
    queryParams.page = 1
    await refreshList()
  },
  { deep: true }
)

onMounted(async () => {
  if (!hasPermission) return
  await refreshList()
})

__expose({
  tableRef,
  getList: () => void refreshList(),
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    tableActOpt: tableActOpt.value,
    firstLoading: false,
    "has-permission": _unref(hasPermission),
    api: dataApi,
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
    onHandleAction: handleAction
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
        "form-columns": filterFormColumns.value,
        disabled: !_unref(hasPermission),
        "show-search": true,
        "search-placeholder": _ctx.$t('softwareManage.searchPlaceholderTerminal'),
        "popover-threshold": 0,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        group_id: _withCtx(() => [
          _createVNode(GroupTreeSelector, {
            width: "100%",
            disabled: !_unref(hasPermission),
            "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
            "default-group-id": groupTreeDefaultId.value,
            onSelected: updateGroupId
          }, null, 8, ["disabled", "terminal-type", "default-group-id"])
        ]),
        actions: _withCtx(() => [
          _createVNode(ExportDropdown, {
            "has-permission": _unref(hasPermission),
            onExport: download
          }, null, 8, ["has-permission"]),
          (props.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                disabled: !_unref(hasPermission),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
    ]),
    computer_name: _withCtx(({ row }: { row?: TerminalUsageData }) => [
      row
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(TerminalIconName, {
              computer_name: row.computer_name,
              system_type: row.system_type,
              login_status: row.login_status
            }, null, 8, ["computer_name", "system_type", "login_status"])
          ]))
        : _createCommentVNode("", true)
    ]),
    ip_address: _withCtx(({ row }: { row?: TerminalUsageData }) => [
      row
        ? (_openBlock(), _createBlock(IPColumn, {
            key: 0,
            cip: row.client_ip,
            sip: row.system_ip
          }, null, 8, ["cip", "sip"]))
        : _createCommentVNode("", true)
    ]),
    active_install_ratio: _withCtx(({ row }: { row?: TerminalUsageData & { active_soft_count?: number; install_soft_count?: number } }) => [
      row
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_progress, {
              class: "install-rate-progress",
              percentage: activeInstallSoftPercent(row),
              "stroke-width": 8,
              "show-text": false
            }, null, 8, ["percentage"]),
            _createElementVNode("span", _hoisted_3, _toDisplayString(row.active_soft_count || 0) + "/" + _toDisplayString(row.install_soft_count || 0), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    avg_duration: _withCtx(({ row }: { row?: TerminalUsageData }) => [
      row
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(formatDuration)(row.duration * 60)), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, "--"))
    ]),
    _: 1
  }, 8, ["tableOpt", "tableActOpt", "has-permission", "modelValue"]))
}
}

})